import {useEffect,useRef,useState} from 'react';
import {advanceRoutePlayback} from '../shared/route-playback.js';
import type {LocalRoutePoint} from './local-api';
/** One elapsed-time clock; pause/speed changes retain the fractional position. */
export function useRouteAnimation(points:LocalRoutePoint[],index:number|undefined,playing:boolean,speed:number,onIndex:(index:number)=>void,identity:string){
 const [fraction,setFraction]=useState(0),cursor=useRef({index,fraction:0}),key=useRef(identity),next=useRef(onIndex);next.current=onIndex;
 if(key.current!==identity||cursor.current.index!==index){key.current=identity;cursor.current={index,fraction:0};}
 useEffect(()=>{setFraction(cursor.current.fraction);},[index,identity]);
 useEffect(()=>{if(!playing||index===undefined)return;let frame=0,last:number|undefined,cancelled=false;
  const tick=(time:number)=>{if(cancelled)return;
   const current=cursor.current,result=advanceRoutePlayback(points,current.index,current.fraction,last===undefined?0:time-last,speed);last=time;
   cursor.current=result;setFraction(result.fraction);
   if(result.index!==current.index)next.current(result.index);
   if(result.index>=points.length-1)return;
   frame=requestAnimationFrame(tick);
  };
  frame=requestAnimationFrame(tick);return()=>{cancelled=true;cancelAnimationFrame(frame);};
 },[points,identity,playing,speed]);
 return cursor.current.index===index?cursor.current.fraction:0;
}
